import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop ordering for landing river frames (admin).
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      draggable: ".landing-frame-row",
      handle: ".landing-frame-handle",
      onEnd: () => this.persist(),
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async persist() {
    const ids = Array.from(this.element.querySelectorAll(".landing-frame-row")).map(
      (row) => row.dataset.frameId,
    )
    await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
      },
      body: JSON.stringify({ ids }),
    })
  }
}
